import classnames from 'classnames';
import React from 'react';
import styled from 'styled-components';

import { SubscriptionRequestWarnings } from '@/types/subscriptions/request';
import { User } from '@/types/user';
import { getFullName } from '@/utils/name';
import { UserWarning } from './UserWarning';

type Props = {
  users: User[];
  warnings?: SubscriptionRequestWarnings | null;
};

export const UsersPreview: React.FC<Props> = ({ users, warnings = null }) => {
  return (
    <Wrapper>
      <tbody>
        {users.map((user, i) => {
          const userWarnings =
            warnings && warnings.users && warnings.users[i]
              ? warnings.users[i]
              : null;

          return (
            <React.Fragment key={`user-${i}-${user.email}`}>
              <tr
                className={classnames('field', {
                  'is-warning': userWarnings,
                })}
              >
                <td className="name" data-test={`confirm-user-${i}-fn`}>
                  {getFullName(user.firstName, user.lastName)}
                </td>
                <td className="kana-name" data-test={`confirm-user-${i}-kfn`}>
                  {getFullName(user.kanaFirstName, user.kanaLastName)}
                </td>
                <td className="email" data-test={`confirm-user-${i}-email`}>
                  {user.email}
                </td>
              </tr>

              {userWarnings && (
                <tr className="warning">
                  <td className="warning-message" colSpan={3}>
                    <UserWarning {...{ userWarnings }} />
                  </td>
                </tr>
              )}
            </React.Fragment>
          );
        })}
      </tbody>
    </Wrapper>
  );
};

const Wrapper = styled.table`
  width: 100%;
  margin-bottom: 56px;
  background: white;
  font-size: 14px;

  border-spacing: 0;
  border-collapse: separate;
  border: 1px solid rgba(34, 36, 38, 0.15);

  tbody > tr.field:first-child > td {
    border-top: none;
  }

  tbody > tr.field > td {
    padding: 7px 11px;
    border-top: 1px solid rgba(34, 36, 38, 0.1);
  }

  tbody > tr.is-warning > td {
    background-color: floralwhite;
    color: #8b4513;
  }
  tbody > tr.warning > td {
    background-color: floralwhite;
    padding: 0 11px 7px 11px;
  }
`;
